import React from "react";
import { Icon, IconProps } from "@chakra-ui/react";

const LockOpenIcon = (props: IconProps) => (
  <Icon viewBox="0 0 16 17" width="16px" height="17px" fill="none" {...props}>
    <mask
      id="mask0_16561_10015"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="16"
      height="17"
    >
      <rect y="0.5" width="16" height="16" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_16561_10015)">
      <path
        d="M3.99935 5.83268H9.99935V4.49935C9.99935 3.94379 9.8049 3.47157 9.41602 3.08268C9.02713 2.69379 8.5549 2.49935 7.99935 2.49935C7.44379 2.49935 6.97157 2.69379 6.58268 3.08268C6.19379 3.47157 5.99935 3.94379 5.99935 4.49935H4.66602C4.66602 3.57713 4.99102 2.79102 5.64102 2.14102C6.29102 1.49102 7.07713 1.16602 7.99935 1.16602C8.92157 1.16602 9.70768 1.49102 10.3577 2.14102C11.0077 2.79102 11.3327 3.57713 11.3327 4.49935V5.83268H11.9993C12.366 5.83268 12.6799 5.96324 12.941 6.22435C13.2021 6.48546 13.3327 6.79935 13.3327 7.16602V13.8327C13.3327 14.1993 13.2021 14.5132 12.941 14.7743C12.6799 15.0355 12.366 15.166 11.9993 15.166H3.99935C3.63268 15.166 3.31879 15.0355 3.05768 14.7743C2.79657 14.5132 2.66602 14.1993 2.66602 13.8327V7.16602C2.66602 6.79935 2.79657 6.48546 3.05768 6.22435C3.31879 5.96324 3.63268 5.83268 3.99935 5.83268ZM3.99935 13.8327H11.9993V7.16602H3.99935V13.8327ZM7.99935 11.8327C8.36602 11.8327 8.6799 11.7021 8.94102 11.441C9.20213 11.1799 9.33268 10.866 9.33268 10.4993C9.33268 10.1327 9.20213 9.81879 8.94102 9.55768C8.6799 9.29657 8.36602 9.16602 7.99935 9.16602C7.63268 9.16602 7.31879 9.29657 7.05768 9.55768C6.79657 9.81879 6.66602 10.1327 6.66602 10.4993C6.66602 10.866 6.79657 11.1799 7.05768 11.441C7.31879 11.7021 7.63268 11.8327 7.99935 11.8327Z"
        fill="#F1B20F"
      />
    </g>
  </Icon>
);

export default LockOpenIcon;
